module.exports = __webpack_public_path__ + "img/infibo-system-components.d15e2dd7.png";